import { FormControl, FormHelperText, InputLabel, MenuItem, Select as MUISelect } from '@mui/material';
import React from 'react'

export default function Select(props) {
    const { name, label, value = "", onChange, error = null, option, ...rest } = props;
    return (
        <FormControl fullWidth {...(error && { error: true })}>
            <InputLabel>{label}</InputLabel>
            <MUISelect
                name={name}
                value={value}
                label={label}
                onChange={onChange}
                {...rest}
            >
                <MenuItem key={0} value="">None</MenuItem>
                {option.map((item) => {
                    return <MenuItem key={item.id} value={item.id}>{item.title}</MenuItem>
                })}
            </MUISelect>
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    )
}
